<template>
  <!--
        作者：kmdshop
        时间：2019-10-25
        描述：权限-管理员列表-添加管理员
    -->
  <el-dialog title="添加客户" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">

    <!--form表单-->
    <el-form size="small" ref="form" :model="form" :rules="formRules" :label-width="formLabelWidth">
      <el-form-item label="客户姓名" prop="nickName" :rules="[{required: true,message: '姓名不能为空'}]">
        <el-input v-model="form.nickName" placeholder="请输入姓名"></el-input>
      </el-form-item>

      <el-form-item label="手机号码" prop="mobile" :rules="[{required: true,message: '手机号不能为空'}]">
        <el-input v-model="form.mobile" maxlength=11 placeholder="请输入手机号码"></el-input>
      </el-form-item>

      <el-form-item label="等级" :label-width="formLabelWidth" >
        <el-select v-model="form.grade_id" placeholder="-默认等级-">
          <el-option v-for="(item,index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="会员等级" prop="role_id">
        <el-select v-model="form.role_id" :multiple="true">
          <el-option v-for="item in roleList" :value="item.role_id" :key="item.role_id" :label="item.role_name_h1"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="会员到期时间" :label-width="formLabelWidth">
        <el-date-picker v-model="form.expire_date_text" type="datetime" placeholder="选择日期时间" align="right" :picker-options="timePickerOpt"></el-date-picker>
        <p class="gray">会员到期时间到了,会员等级自动降级到 {{ (gradeList && gradeList.length > 0) ? '[' + gradeList[0].name + ']' : '默认等级' }}</p>
      </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import UserApi from '@/api/user.js';
export default {
  data() {
    return {
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      loading: false,
      /*是否显示*/
      dialogVisible: false,
      /*form表单对象*/
      form: {
        nickName: '',
        access_id: [],
        // 会员到期时间设置
        expire_date_text: '',
      },
      /*form验证*/
      formRules: {
        nickName: [
          {
            required: true,
            message: '名字不能不为空',
            trigger: 'blur'
          }
        ],
        grade_id: [
          {
            required: true,
            message: ' ',
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: '手机号码不能为空',
            trigger: 'blur'
          }
        ],
      },
      // 会员到期时间选择器左侧快捷选项
      timePickerOpt: {
        shortcuts: [{
          text: '一年',
          onClick(picker) {
            const date = new Date()
            date.setFullYear(date.getFullYear() + 1)
            picker.$emit('pick', date)
          }
        }, {
          text: '两年',
          onClick(picker) {
            const date = new Date()
            date.setFullYear(date.getFullYear() + 2)
            picker.$emit('pick', date)
          }
        }, {
          text: '三年',
          onClick(picker) {
            const date = new Date()
            date.setFullYear(date.getFullYear() + 3)
            picker.$emit('pick', date)
          }
        }]
      },
    };
  },
  props: ['open', 'roleList','gradeList'],
  watch: {
    open: function(n, o) {
      if (n != o) {
        this.dialogVisible = this.open;
      }
    }
  },
  created() {},
  methods: {
    /*添加*/
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = self.form;
      self.$refs.form.validate((valid) => {
        if(valid){
            UserApi.adduser(params, true)
          .then(data => {
            self.loading = false;
            self.$message({
              message: '添加成功',
              type: 'success'
            });
            this.form.nickName=''
            this.form.mobile=''
            this.form.grade_id=''
            self.dialogFormVisible(true);
          })
          .catch(error => {
            self.loading = false;
          });
        }if(!valid){
          self.loading = false;
        }

      });


    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('close', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('close', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/Add.vue